import React from 'react';
import Head from 'next/head';
import { GetStaticProps, NextPage } from 'next';
import Hero from 'day8-react/build/new-components/Hero/Hero';
import FaqList from 'day8-react/build/new-components/FaqList/FaqList';
import ComponentWrapper from 'day8-react/build/new-components/helpers/ComponentWrapper';
import ComponentVerticalSpacing from 'day8-react/build/new-components/helpers/ComponentVerticalSpacing';


import Intro from '../components/CrewFinder/Intro';
import Content from '../components/CrewFinder/Content';
import PageLayout from '../layouts/page';

import { WpPageType } from '../globalTypes';
import wp, { sanitizeWpResponse } from '../helpers/wp';

type CrewFinderPage = {
  page: WpPageType & {
    acf: {
      intro: {},
      vision: {},
      content: {}
      faqlist: {
        category: string
        title: string
        text: string
      }
    }
  }
}
const CrewFinder: NextPage<CrewFinderPage> = ({ page }) => {
  const {
    hero,
    intro,
    content,
    faqlist
  } = page.acf;
  return (
    <PageLayout page={page}>
      <Head>
        <title>Crew Finder</title>
      </Head>
      {hero && (
        <Hero
          title={hero.title}
          subtitle={hero.subtitle}
          bgImage={hero.background}
          video={hero.video}
          poster={hero.poster}
          template={hero.video ? 'Video' : 'Basic'}
          cta={hero.button}
          mobileVideo={hero.mobile_video}
          mobilePoster={hero.mobile_poster}
          mobileBgImage={hero.mobile_background}
          overlay
          whiteFont
          centeredDesktop
        />
      )}
      <div id="smooth-scroll-hook" />
      {intro && (<Intro intro={intro} />)}
      {content && (<Content content={content} />)}
      {faqlist && (
        <ComponentVerticalSpacing>
          <ComponentWrapper className="max-width-md margin-auto">
            <FaqList
              categorySlug={faqlist.category}
              categoryTitle={faqlist.title}
              text={faqlist.text}
            />
          </ComponentWrapper>
        </ComponentVerticalSpacing>
      )}
    </PageLayout>
  );
};


export const getStaticProps: GetStaticProps = async () => {
  try {
    const pages: WpPageType[] = await wp.pages().slug('crew-finder').get();
    return {
      props: {
        page: sanitizeWpResponse(pages[0])
      },
      revalidate: 300
    };
  } catch (e) {
    return { notFound: true };
  }
};

export default CrewFinder;